import { Component, OnInit,Input,ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/';
import { map } from 'rxjs/operators';
// import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { AlertService, AreaOfInterestService,AppService } from '../_services/index';
import {NgbModal, NgbActiveModal,NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';

class AreaOfInterest {
  id: number;
  name: string;
  description: string;
  is_active: string;
}

@Component({
  selector: 'app-area-of-interest',
  templateUrl: './area-of-interest.component.html'
})
export class AreaOfInterestComponent implements OnInit {
  loading: boolean = false; 
  dtOptions: DataTables.Settings = {}; //  DataTable
	dtTrigger = new Subject(); //  DataTable
	areaofinterestList: AreaOfInterest[] = []; // Table Data list
  isSubmitted = false;
  // countryAddForm: FormGroup;
	getAreaOfInterest = {
    id:'',
    name: '',
    description: '',
    is_active: 'N'
  };

  modalReference:NgbActiveModal;
  modalTitle:string;
	constructor(
              public router: Router,
              private dataService:AreaOfInterestService,
              private alertService: AlertService,
              private AppService: AppService,
              private modalService: NgbModal
             ) { }
  areaofinterest = {
    id:'',
    name: '',
    description: '',
    is_active: 'Y'
  };
  showloding = true;
  lodingImage = false;

	ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.allAreaofinterest();
  }

  allAreaofinterest(){
    this.loadShow();
    this.dataService.getAllAreaofinterest()
        .pipe().subscribe(data => { 
          this.areaofinterestList = data['areaofinterest']; 
          this.dtTrigger.next(); // Data Table
          this.loadHide();
        });
      }

	open(content) {
    if (this.getAreaOfInterest.id !=null) {
      this.getAreaOfInterest.id='';
    }
    this.isSubmitted = false;
    this.areaofinterest.name = '',
    this.areaofinterest.description = '',
    this.areaofinterest.is_active = 'Y';
    this.modalTitle = "Add area of interest";
    this.modalReference = this.modalService.open(content);
  }


  edit(id,content){
    this.loadShow();
    this.dataService.getAreaOfInterest(id)
        .pipe().subscribe(data => { 
                this.getAreaOfInterest = data['areaofinterest']; 
                this.areaofinterest = {
                      id:this.getAreaOfInterest.id,
                      name:this.getAreaOfInterest.name,
                      description:this.getAreaOfInterest.description,
                      is_active:this.getAreaOfInterest.is_active
                   };
                this.loadHide();
                this.modalTitle = "Edit area of interest";
                this.modalReference = this.modalService.open(content);
             });
          }
 
	save(val,f){
    this.isSubmitted = true;
    if(f.form.valid) {
      this.loadShow()
      if(val.id == ''){
        this.dataService.save(this.areaofinterest)
            .pipe().subscribe(data =>{
              if(data['status'] == 200){
                this.loadHide()
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area of interest saved successfully', true);
                this.allAreaofinterest();
              }
              else if(data['status'] == 422){
                this.alertService.error(data.mesg.name)
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                this.loadHide()
              }else{
                this.alertService.error(data.message)
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
                this.loadHide()
              }
              
            },error =>{
              
            });
      }else{
        this.dataService.areaofinterestUpdate(this.areaofinterest)
            .pipe().subscribe(data =>{
              if(data['status'] ==200){
                this.loadHide()
                this.modalReference.close();
                this.dtTrigger = new Subject(); //  DataTable
                this.alertService.success('Area of interest updated successfully', true);
                this.allAreaofinterest();
              }else if(data['status'] ==300){
                this.loadHide()
                this.alertService.error(data.mesg);
                document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
              }
              
            },error =>{
              this.loadHide()
              this.alertService.error(error);
              document.querySelector(".modal").scrollTo({top:0,behavior:'smooth'});
            });
          }
        }
	    }


  delete(id){
    if(confirm("Are you sure to delete")) {
      this.dataService.areaofinterestDelete(id)
          .pipe().subscribe(data =>{
            if(data['status']==200){
              this.dtTrigger = new Subject(); //  DataTable
              this.alertService.success('Area of interest deleted successfully', true);
              this.allAreaofinterest();
            }else{
              this.alertService.error('Area of interest error');
            }
          },error =>{
            this.alertService.error(error);
          });
        }
      }


  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }
}
